import { Button } from '@heroui/react';
import React from 'react';
import { FiAlertCircle, FiRefreshCw } from 'react-icons/fi';

interface OrderListErrorStateProps {
  error: Error | null;
  onRetry: () => void;
}

export const OrderListErrorState: React.FC<OrderListErrorStateProps> = ({
  error,
  onRetry,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <FiAlertCircle className="h-12 w-12 text-danger mb-4" />
      <h2 className="text-xl font-semibold text-foreground mb-2">
        Failed to load orders
      </h2>
      <p className="text-default-500 text-center mb-6 max-w-md">
        {error?.message || 'An unexpected error occurred while loading orders.'}
      </p>
      <Button
        color="primary"
        variant="solid"
        startContent={<FiRefreshCw className="h-4 w-4" />}
        onPress={onRetry}
      >
        Retry
      </Button>
    </div>
  );
};
